var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/widgets/category/list/items-placeholder-template.tpl
// module id = 858
// module chunks = 2 3